'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster, ToastProvider } from 'ui/toast'
import { useState } from 'react'
import { LanguageProvider } from 'i11n/client'
import { ChakraProvider } from '@chakra-ui/react'
import { NuqsAdapter } from 'nuqs/adapters/next/app'

export const Providers = ({ children }: { children: React.ReactNode }) => {
  const [queryClient] = useState(new QueryClient())

  return (
    <NuqsAdapter>
      <LanguageProvider lang='es'>
        <QueryClientProvider client={queryClient}>
          <Toaster />
          {children}
        </QueryClientProvider>
      </LanguageProvider>
    </NuqsAdapter>
  )
}
